export const SET_USER_INFO = "SET_USER_INFO";
export const UPDATE_LANGUAGE = "SET_LANGUAGE";